import { useState } from "react"
import { Link } from "react-router-dom"

const AgeAuthentication = ({ setVerified, setMocktails}) => {
    const [msg, setMsg] = useState(false)
    const [cocktails, setCocktails] = useState(false)

    return (
        <div className=" tt-verification-container vh-100 d-flex flex-column justify-content-center align-items-center bg-primary">
            <div className="tt-verification-card border border-dark border-2 rounded-2 h-50 d-flex flex-column  p-3 bg-white mx-4">
                <h3 className="text-start px-2">THIRST TRAP</h3>
                { !cocktails ?
                <div className="d-flex justify-content-center align-items-center h-100">
                        <div>
                            <h1 className="fw-bold text-center">Are you here for <span className="">Cocktails</span> or <span className="">Mocktails</span>?</h1>
                            <div className="my-5 d-flex justify-content-evenly w-100">
                                    <button className="btn tt-button" onClick={() => {
                                        setCocktails(true)
                                    }}  >Cocktails</button>                               

                                    <button className="btn tt-button bg-white" onClick={() => {
                                        setMocktails(true)
                                    }} >Mocktails</button>                                

                            </div>
                        </div> 
                </div> :
                <div className="d-flex justify-content-center align-items-center h-100">
                    {msg ? 
                        <div className="text-center ">
                            <h1 className="fw-bold text-center "> You must be of <span className="">legal drinking age</span> to enter this site</h1>     
                                    <h5 className=" fw-bold pt-3"  >
                                        View our mocktails instead 
                                        <Link to="/products" >
                                            <button className="ms-3 tt-button btn bi bi-arrow-right"
                                                    onClick={() => {
                                                        setMocktails(true)
                                                    }}
                                            >
                                            </button>
                                        </Link>
                                    </h5>                    
                        </div>:
                        <div>
                            <h1 className="fw-bold text-center">Are you of <span className="">legal age</span> to drink?</h1>
                            <div className="my-5 d-flex justify-content-evenly w-100">
                                <Link to="/"><button className="btn tt-button" onClick={() => {
                                    setVerified(true)
                                }}  >I'm over 21</button></Link>
                                <button className="btn tt-button bg-white" onClick={() => {
                                    setVerified(false)
                                    setMsg(true)
                                }} >Not yet</button>
                            </div>
                        </div>
                    }
                </div>
                }
            </div>
        </div>
    )
}

export default AgeAuthentication